export const colors = {
  $white: '#fff',
  $black: '#000000',

  $gray50: '#fafafa',
  $gray100: '#f4f4f5',
  $gray200: '#e4e4e7',
  $gray300: '#d4d4d8',
  $gray400: '#a1a1aa',
  $gray500: '#71717a',
  $gray600: '#52525b',
  $gray700: '#3f3f46',
  $gray800: '#27272a',
  $gray900: '#18181b',
  $gray950: '#09090b',

  $red: '#f92e48',

  $successGreen100: '#eef9f6',
  $successGreen200: '#4cbfa4',
  $warnYellow200: '#fcb100',
  $errorRed100: '#fbeded',
  $errorRed200: '#d14343',
};
